
import { Button, Flex, Heading, Input, InputGroup, InputLeftAddon, Spinner, Stack, Text } from '@chakra-ui/react';
import {
    getUserByIdRequest,
  getUserResponse,
  UpdateCurrentUserRequest,
  UpdateCurrentUserResponse
} from '../../../shared';
import { FormEvent, useCallback, useEffect, useState } from 'react';
import { ApiError, callEndpoint } from '../fetch';
import { useCurrentUser } from '../components/user-context';
import { ENDPOINT_CONFIGS, withParams } from '../endpoints';
import { getLocalStorageID, onUpdateUserProfile } from '../fetch/auth';
import { CheckCircleIcon } from '@chakra-ui/icons';

enum UserProfileMode {
  EDITING,
  VIEWING,
}

export const UserProfile = () => {
  const id = getLocalStorageID();
  const [userName, setUserName] = useState<string | undefined>();
  const [userPhone, setUserPhone] = useState<string | undefined>();
  const [userAddress, setUserAddress] = useState<string | undefined>();
  const [userProfileMode, setUserProfileMode] = useState(UserProfileMode.VIEWING);
  const [userUpdateError, setUserUpdateError] = useState<string>();
  const { currentUser, refreshCurrentUser } = useCurrentUser();
  const isOwnProfile = id === currentUser?.id;
  const isEditingMode = userProfileMode === UserProfileMode.EDITING;
  const [changePassword, setChangePassword] = useState(false);
  const [oldPassword, setOldPassword] = useState<string | undefined>();
  const [newPassword, setNewPassword] = useState<string | undefined>();
  const [confirmPassword, setConfirmPassword] = useState<string | undefined>();
  const [resOk,setResOk]=useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  // load user profile



  useEffect(()=>{
  
    const fetchData = async()=>{
    try{
      const res= await callEndpoint<getUserByIdRequest, getUserResponse>(withParams(ENDPOINT_CONFIGS.getUserById, id!));
      setUserName(res.name);
      setUserAddress(res.address);
      setUserPhone(res.phone);
      setBusy(false);
      } catch (e) {
        setError((e as ApiError).message);
        setBusy(false);
      }
    }
    fetchData();
    
    },[])

  const updateCurrentUser = useCallback(async () => {
    await callEndpoint<UpdateCurrentUserRequest, UpdateCurrentUserResponse>(
      ENDPOINT_CONFIGS.updateCurrentUser,
      {
        address:userAddress!,
        name:userName!,
        password:newPassword!,
        phone:userPhone!,
        oldPassword:oldPassword!
      }
    );
  }, [userName, userAddress, newPassword, oldPassword, confirmPassword, userPhone]);

  const handleSaveClick = async () => {
    setResOk(false);
    setBusy(true);
    if(newPassword!== confirmPassword){
      setUserUpdateError('كلمتا المرور غير متطابقتين');
      setBusy(false);
      return;
    }

    try {
      await updateCurrentUser();
      setUserUpdateError('');
      refreshCurrentUser();
      onUpdateUserProfile(userName!,userPhone!,userAddress!);
      setUserProfileMode(UserProfileMode.VIEWING);
      setResOk(true);
      setBusy(false);
    } catch (e) {
      setUserUpdateError((e as ApiError).message);
      setBusy(false);
    }
  };

  const handleEditClick = () => {
    setUserProfileMode(UserProfileMode.EDITING);
    setResOk(false);
  };

  const onEditOrSaveClick = async (e: FormEvent | MouseEvent) => {
    e.preventDefault();
    if (userProfileMode === UserProfileMode.EDITING) {
      await handleSaveClick();
    } else if (userProfileMode === UserProfileMode.VIEWING) {
      handleEditClick();
    }
  };

  if(busy){
    return(
      <div>
         <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
        <Spinner></Spinner>
        </Flex>
      </div>
    )
  }
  
  if (error){
  return(
    <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
      {error}
    </Flex>
  );}

  return (
    <form onSubmit={onEditOrSaveClick} dir="rtl">
        <fieldset disabled={busy}>
    <Flex maxW="sm" mx="auto" my={10} direction="column" gap={4}>
      <Heading textAlign={'center'}>بيانات المستخدم</Heading>
      <InputGroup>
        <InputLeftAddon children="الاسم" />
        <Input
          paddingLeft={4}
          value={userName}
          isDisabled={!isEditingMode}
          isRequired={true}
          onChange={e => setUserName(e.target.value)}
        />
      </InputGroup>
      <InputGroup>
        <InputLeftAddon children="التليفون" />
        <Input
          paddingLeft={4}
          value={userPhone}
          isDisabled={!isEditingMode}
          isRequired={true}
          onChange={e => setUserPhone(e.target.value)}
        />
      </InputGroup>
      <InputGroup>
        <InputLeftAddon children="العنوان" />
        <Input
          paddingLeft={4}
          value={userAddress}
          isDisabled={!isEditingMode}
          onChange={e => setUserAddress(e.target.value)}
        />
      </InputGroup>
      {changePassword &&
      <>
      <InputGroup>
        <InputLeftAddon children="كلمة المرور القديمة" />
        <Input
          paddingLeft={4}
          type='password'
          value={oldPassword}
          isRequired={true}
          onChange={e => setOldPassword(e.target.value)}
        />
      </InputGroup>
      <InputGroup>
      <InputLeftAddon children="كلمة المرور الجديدة" />
      <Input
        paddingLeft={4}
        type='password'
        value={newPassword}
        isRequired={true}
        onChange={e => setNewPassword(e.target.value)}
      />
    </InputGroup>
    <InputGroup>
    <InputLeftAddon children="تأكيد كلمة المرور" />
    <Input
      paddingLeft={4}
      type='password'
      value={confirmPassword}
      isRequired={true}
      onChange={e => setConfirmPassword(e.target.value)}
    />
  </InputGroup>
  </>
  }
      {isOwnProfile && (
<>
        {!changePassword &&
        <Button
          type= 'button'
          variant='link'
          size="sm"
          display="block"
          onClick={()=>{setChangePassword(true); setUserProfileMode(UserProfileMode.EDITING);}}
          >  
          تغيير كلمة المرور     
        </Button>
        }

        <Button
          type="submit"
          variant={isEditingMode ? 'solid' : 'outline'}
          size="sm"
          display="block"
          
        >
          {isEditingMode ? 'حفظ' : 'تعديل البيانات'}
        </Button>
        {resOk && 
              <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CheckCircleIcon boxSize={'20px'} color={'green.500'} />                           
                <Text color="green">تم التعديل بنجاح</Text>               
              </Stack>             
              }
        </>
      )}

      {!!userUpdateError && <Text color="red.700">{userUpdateError}</Text>}
      {busy &&  
          <Stack pt={4}>
            <Spinner  alignSelf={'center'} />
            </Stack>
            }
    </Flex>
    </fieldset>
    </form>
  );
};